import React from 'react';
import ErrorBoundaries from '../../../components/ErrorBoundaries';
import EinstellungenSeitenKopf from '../components';
import ContractTypsTable from './components/ContractTypsTable';

function ContractTypsPage() {
  return (
    <>
      <EinstellungenSeitenKopf title="Vertragsarten" />
      <ErrorBoundaries>
        <ContractTypsTable />
      </ErrorBoundaries>
    </>
  );
}
export default ContractTypsPage;
